export default {"src":"/_next/static/media/tag-icon.abe173d8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};